import { Alert } from '@playerbase/ui';

import { useToast } from './use-toast.js';

// Fixed bottom-right stack. Rendered once near the shell root so toasts
// overlay every authenticated route. Each toast uses the Alert atom for its
// tonal styling; the flash-once keyframe (packages/ui tailwind preset) gives
// a subtle entry without pulling in an animation library.
//
// aria-live is already on Alert (polite); the wrapping region is a plain
// container so screen readers announce each toast as it mounts.
export function ToastViewport(): JSX.Element | null {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 flex w-full max-w-sm flex-col gap-2">
      {toasts.map((toast) => (
        <Alert
          key={toast.id}
          tone={toast.tone}
          className="pointer-events-auto animate-flash-once shadow-lg"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="font-medium">{toast.title}</p>
              {toast.body !== undefined && (
                <p className="mt-0.5 text-xs opacity-90">{toast.body}</p>
              )}
            </div>
            <button
              type="button"
              aria-label="Dismiss"
              onClick={() => dismiss(toast.id)}
              className="-mr-1 -mt-1 shrink-0 rounded p-1 text-lg leading-none opacity-70 hover:opacity-100"
            >
              ×
            </button>
          </div>
        </Alert>
      ))}
    </div>
  );
}
